import {Component, Input} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {OrdineEsolver} from '../../../_models/OrdineEsolver';

@Component({
  selector: 'app-seleziona-fase-conto-lavoro-modal',
  templateUrl: './seleziona-fase-conto-lavoro-modal.component.html',
  styleUrls: ['./seleziona-fase-conto-lavoro-modal.component.scss'],
  standalone: false
})
export class SelezionaFaseContoLavoroModalComponent {
  @Input() fasi: OrdineEsolver[] = [];

  constructor(private modalCtrl: ModalController) { }

  seleziona = (fase: OrdineEsolver) => this.modalCtrl.dismiss(fase, 'confirm');

  cancel = () => this.modalCtrl.dismiss(null, 'cancel');
}
